exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-93e35564] .vs-popup--close {\n  display: none !important;\n}\n", ""]);

// exports
